import BaseService, {BaseServiceLevel2} from "@/services/base.service";
import store from "@/store/store";
import $const from "@/utils/const";
import $http from "@/plugins/axios";

const AgentMode = {
    EDITING: 'EDITING', VIEWING: 'VIEWING'
}

const UserRole = {
    OWNER: 'OWNER', ADMIN: 'ADMIN', EDITOR: 'EDITOR', TESTER: 'TESTER'
}

const AgentActions = {
    MANAGE_PERMISSION: 'MANAGE_PERMISSION', AUDIT: 'AUDIT', HISTORY: 'HISTORY',
}

const AgentServiceCRUD = BaseService('tova-agents')
const AgentService = {
    CRUD: AgentServiceCRUD,
    UserService: BaseServiceLevel2('tova-agents', 'users'),
    SettingService: BaseServiceLevel2('tova-agents', 'settings'),
    HistoryService: BaseServiceLevel2('tova-agents', 'histories'),
    AgentActions,
    AgentMode,
    UserRole,
    isEditable() { // check role edit for all system
        let state = store.state
        let isAdmin = state.user.profile.roles?.includes('admin')
        if (isAdmin) {
            return true
        }

        let role = state.agent.agent ? state.agent.agent.role : ''
        return role === UserRole.OWNER || role === UserRole.EDITOR || role === UserRole.ADMIN
    },
    isEditor() { // check role admin or owner
        let state = store.state
        let role = state.agent.agent ? state.agent.agent.role : ''
        return role === UserRole.EDITOR
    },
    isAdminOrOwner() {
        let state = store.state
        let isAdmin = state.user.profile.roles?.includes('admin')
        if (isAdmin) {
            return true
        }
        let role = state.agent.agent ? state.agent.agent.role : ''
        return role === UserRole.OWNER || role === UserRole.ADMIN
    },
    sendMessage(agentId, callId, msgType, message, userAttributes = {}) {
        let dataPayload = {
            call_id: callId,
            type: msgType,
            message: {
                content: message
            },
            user_attributes: {
                name: 'test - name',
                phone: 'test - phone',
                ...userAttributes,
            }
        }
        return $http.post(`/tova-agents/${agentId}/chat-completion/`, dataPayload)
    },
    getSystemConfigs() {
        return $http.get(`/tova-system-configs/`)
    },
    getQuickReactionTemplate(agentId) {
        return $http.get(`/tova-agents/${agentId}/template-quick-reaction/`, {responseType: 'blob'})
    },
}
export default AgentService
